<template>
    <div class="p-grid">
        <div class="p-col-12">
            <div class="card">
                <h4 v-if="client && client.key && site && site.key" class="p-d-flex p-ai-baseline">
                    <router-link icon="pi pi-angle-left" class="p-button p-button-icon p-mr-4" v-if="client && client.key" :to="{ name: 'site', params: { client_id: client.key, id: site.key } }">
                        <i class="pi pi-angle-left"></i>
                        Back
                    </router-link>
                    <span>
                        <router-link :to="{ name: 'sites', params: { id: client.key } }">{{ client.name }}</router-link>
                        /
                        <router-link :to="{ name: 'site', params: { client_id: client.key, id: site.key } }">{{
                            site.name
                        }}</router-link> /
                        Assets
                    </span>
                </h4>
                <div class="asset_list">
                    <!-- <button @click="updateAssetsButton">update assets</button> -->
                    <small>Use CTRL + click to select multiple rows and SHIFT + click to select a range of rows</small>
                    <div id="asset_filters">
                        <div id="asset_id_search">
                            <span>Asset ID</span>
                            <InputNumber :useGrouping="false" v-model="AssetFilters.asset_id" placeholder="Search Asset ID" />
                        </div>
                        <div>
                            <span>Name</span>
                            <!-- <InputText v-model="AssetFilters.name" placeholder="Search Name, Category, Make or Model" /> -->
                            <MultiSelect v-model="AssetFilters.name" :options="filterOptions.name" display="chip" filter placeholder="Select Name" class="p-column-filter select_filter" :disabled="filterOptions.name ? false : true" @show="triggerLabel()" @change="triggerChip()">
                            </MultiSelect>
                        </div>
                        <div class="select_filter">
                            <span>Category</span>
                            <MultiSelect v-model="AssetFilters.category" :options="filterOptions.category" display="chip" filter placeholder="Select Category" class="p-column-filter select_filter" :disabled="filterOptions.category ? false : true" @show="triggerLabel()" @change="triggerChip()">
                            </MultiSelect>
                        </div>
                        <div class="select_filter">
                            <span>Type</span>
                            <MultiSelect v-model="AssetFilters.asset_type" :options="filterOptions.asset_type" display="chip" filter placeholder="Select Type" class="p-column-filter select_filter" :disabled="filterOptions.asset_type ? false : true" @show="triggerLabel()" @change="triggerChip()">
                            </MultiSelect>
                        </div>
                        <div class="select_filter">
                            <span>Sub-Area</span>
                            <MultiSelect v-model="AssetFilters.location" :options="filterOptions.location" display="chip" filter placeholder="Select Sub-Area" class="p-column-filter select_filter" :disabled="filterOptions.location ? false : true" @show="triggerLabel()" @change="triggerChip()">
                            </MultiSelect>
                        </div>
                        <div class="select_filter">
                            <span>Area</span>
                            <MultiSelect v-model="AssetFilters.area" :options="filterOptions.area" display="chip" filter placeholder="Select Area" class="p-column-filter select_filter" :disabled="filterOptions.area ? false : true" @show="triggerLabel()" @change="triggerChip()">
                            </MultiSelect>
                        </div>
                        <div class="select_filter">
                            <span>Make</span>
                            <MultiSelect v-model="AssetFilters.make" :options="filterOptions.make" display="chip" filter placeholder="Select Make" class="p-column-filter select_filter" :disabled="filterOptions.make ? false : true" @show="triggerLabel()" @change="triggerChip()">
                            </MultiSelect>
                        </div>
                        <div class="select_filter">
                            <span>Model</span>
                            <MultiSelect v-model="AssetFilters.model" :options="filterOptions.model" display="chip" filter placeholder="Select Model" class="p-column-filter select_filter" :disabled="filterOptions.model ? false : true" @show="triggerLabel()" @change="triggerChip()">
                            </MultiSelect>
                        </div>
                        <div class="select_filter select_filter--date">
                            <span>Install Date</span>
                            <div>
                                <i class="pi pi-calendar-plus" style="font-size: 16px"></i>
                                <Calendar @hide="triggerClose(installDatePreParse, 'install_date')" v-model="installDatePreParse" :manualInput="false" selectionMode="range" placeholder="Select Date Range" dateFormat="d M yy" style="flex-grow: 1;" />
                            </div>
                        </div>
                        <div class="select_filter select_filter--date">
                            <span>Lifecycle Expiry Date</span>
                            <div>
                                <i class="pi pi-calendar-plus" style="font-size: 16px"></i>
                                <Calendar @hide="triggerClose(lifecycleDatePreParse, 'lifecycle_expiry_date')" v-model="lifecycleDatePreParse" :manualInput="false" selectionMode="range" placeholder="Select Date Range" dateFormat="d M yy" style="flex-grow: 1;" />
                            </div>
                        </div>
                        <div class="select_filter">
                            <span>Lifecycle Status</span>
                            <MultiSelect v-model="lifecycle_status_sender" :options="filterOptions.lifecycle_status" display="chip" filter placeholder="Select Status" class="p-column-filter select_filter" :disabled="filterOptions.lifecycle_status ? false : true" @show="triggerLabel()" @change="triggerChip()">
                            </MultiSelect>
                        </div>
                        <div class="select_filter select_filter--date">
                            <span>Last Maintained Date</span>
                            <div>
                                <i class="pi pi-calendar-plus" style="font-size: 16px"></i>
                                <Calendar @hide="triggerClose(maintainanceDatePreParse, 'last_maintained_date')" v-model="maintainanceDatePreParse" :manualInput="false" selectionMode="range" placeholder="Select Date Range" dateFormat="d M yy" style="flex-grow: 1;" />
                            </div>
                        </div>
                        <div class="select_filter select_filter--date">
                            <span>Maintenance Schedule Start Date</span>
                            <div>
                                <i class="pi pi-calendar-plus" style="font-size: 16px"></i>
                                <Calendar @hide="triggerClose(maintenanceScheduleStartDatePreParse, 'maintenance_schedule_start_date')" v-model="maintenanceScheduleStartDatePreParse" :manualInput="false" selectionMode="range" placeholder="Select Date Range" dateFormat="d M yy" style="flex-grow: 1;" />
                            </div>
                        </div>
                        <div class="select_filter">
                            <span>Maintenance / Attendance Status</span>
                            <MultiSelect v-model="maintenance_status_sender" :options="filterOptions.maintenance_status" display="chip" filter placeholder="Select Status" class="p-column-filter select_filter" :disabled="filterOptions.maintenance_status ? false : true" @show="triggerLabel()" @change="triggerChip()">
                            </MultiSelect>
                        </div>
                        <div class="select_filter">
                            <span>Last Report</span>
                            <MultiSelect v-model="AssetFilters.maintenance_current_status" :options="filterOptions.maintenance_current_status" display="chip" filter placeholder="Select Result" class="p-column-filter select_filter" :disabled="filterOptions.maintenance_current_status ? false : true" @show="triggerLabel()" @change="triggerChip()">
                            </MultiSelect>
                        </div>
                        <div class="select_filter select_filter--date">
                            <span>Warranty Expiry Date</span>
                            <div>
                                <i class="pi pi-calendar-plus" style="font-size: 16px"></i>
                                <Calendar @hide="triggerClose(warrantyDatePreParse, 'warranty_expiry_date')" v-model="warrantyDatePreParse" :manualInput="false" selectionMode="range" placeholder="Select Date Range" dateFormat="d M yy" style="flex-grow: 1;" />
                            </div>
                        </div>
                        <div class="select_filter">
                            <span>Warranty Status</span>
                            <MultiSelect v-model="warranty_status_sender" :options="filterOptions.warranty_status" display="chip" filter placeholder="Select Status" :disabled="filterOptions.warranty_status ? false : true" @show="triggerLabel()" @change="triggerChip()" class="p-column-filter select_filter">
                            </MultiSelect>
                        </div>
                        <div class="select_filter">
                            <span>Fault Status</span>
                            <MultiSelect v-model="AssetFilters.fault_status" :options="filterOptions.fault_status" display="chip" filter placeholder="Select Status" :disabled="filterOptions.fault_status ? false : true" @show="triggerLabel()" @change="triggerChip()" class="p-column-filter select_filter">
                            </MultiSelect>
                        </div>
                    </div>
                </div>
                <DataTable :key="tableKey" :first="pagination.first" :paginator="(useFilteredValues == true) ? true : false" :value="siteAssetSnapshotData" :rows="20" class="asset_list" ref="asset_table" :selection.sync="selectedRows" :loading="loading" selectionMode="multiple" sortField="asset_id" :sortOrder="1" @page="triggerNewPagination">
                    <template #header>


                        <div id="button_row">
                            <Button type="button" icon="pi pi-search" label="Search Assets" classs="p-button-primary" style="margin-right: 1rem;" @click.prevent="searchFilters()" />
                            <Button type="button" icon="pi pi-replay" label="Reset Filters" id="reset_filters" @click.prevent="clearFilters()" />
                            <Button type="button" :label="selectedRows.length == 1 ? 'Delete Asset' : 'Delete Assets'" icon="pi pi-trash" id="delete_button" @click.prevent="displayConfirmation = true" :disabled="selectedRows.length > 0 ? false : true" v-if="(user.role.permissionLevel >= 10)" />
                            <div>
                                <Button type="button" icon="pi pi-pencil" label="Bulk Edit" @click.prevent="toggleSidebar = true" />
                                <!-- <Button type="button" icon="pi pi-sign-in" label="Import" disabled /> -->
                                <Button label="New Asset Batch" icon="pi pi-plus" class="p-button-secondary" @click="visibleRight = true" iconPos="left" v-if="(user.role.permissionLevel >= 10)" />
                            </div>
                        </div>

                    </template>
                    <template #empty>
                        No assets found.
                    </template>
                    <template #loading>
                        Loading asset data. Please wait.
                    </template>
                    <!-- <Column selectionMode="multiple" headerClass="table__button--header" bodyClass="table__button"/> -->
                    <Column field="asset_id" header="ID" headerClass="id_column" sortable>
                        <template #body="slotProps">
                            <span>{{ forceFourDigits(slotProps.data.asset_id) }}<span v-if="slotProps.data.restored_from_other_site">*</span></span>
                        </template>
                    </Column>
                    <Column field="name" header="Name" headerClass="name_column" sortable>
                        <template #body="slotProps">
                            <span v-if="slotProps.data.name">
                                <router-link class="edit_link" v-if="slotProps.data.asset_type" :to="{ name: 'asset', params: { id: slotProps.data.key, site_id: slotProps.data.site_id, template_id: slotProps.data.template_id } }">
                                    {{ slotProps.data.name }}
                                </router-link>
                                <span v-else>{{ slotProps.data.name }}</span>
                            </span>
                            <span v-else>
                                <router-link class="edit_link" v-if="slotProps.data.asset_type" :to="{ name: 'asset', params: { id: slotProps.data.key, site_id: slotProps.data.site_id, template_id: slotProps.data.template_id } }">
                                    <i>No Name Assigned</i>
                                </router-link>
                                <span v-else><i>No Name Assigned</i></span>
                            </span>
                        </template>
                    </Column>
                    <Column field="asset_type" header="Type" headerClass="type_column" sortable>
                        <template #body="slotProps">
                            <span v-if="slotProps.data.asset_type">{{ slotProps.data.asset_type }}</span>
                            <span v-else><i>No Type Assigned</i></span>
                        </template>
                    </Column>
                    <Column field="category" header="Category" sortable>
                        <template #body="slotProps">
                            <span v-if="slotProps.data.category">{{ slotProps.data.category }}</span>
                            <span v-else>
                                <i v-if="slotProps.data.asset_type == 'Asset'">No Category Assigned</i>
                                <i v-else>N/A</i>
                            </span>
                        </template>
                    </Column>
                    <Column field="area" header="Area" sortable>
                        <template #body="slotProps">
                            <span v-if="slotProps.data.area">{{ slotProps.data.area }}</span>
                            <span v-else><i>No Area Assigned</i></span>
                        </template>
                    </Column>
                    <Column field="location" header="Sub-Area" sortable>
                        <template #body="slotProps">
                            <span v-if="slotProps.data.location">{{ slotProps.data.location }}</span>
                            <span v-else><i>No Sub-Area Assigned</i></span>
                        </template>
                    </Column>
                    <Column field="make" header="Make" sortable>
                        <template #body="slotProps">
                            <span v-if="slotProps.data.make">{{ slotProps.data.make }}</span>
                            <span v-else>
                                <i v-if="slotProps.data.asset_type == 'Asset'">No Make Assigned</i>
                                <i v-else>N/A</i>
                            </span>
                        </template>
                    </Column>
                    <Column field="model" header="Model" sortable>
                        <template #body="slotProps">
                            <span v-if="slotProps.data.model">{{ slotProps.data.model }}</span>
                            <span v-else>
                                <i v-if="slotProps.data.asset_type == 'Asset'">No Model Assigned</i>
                                <i v-else>N/A</i>
                            </span>
                        </template>
                    </Column>
                    <Column field="maintenance_status.asset_page_label" header="Maintenance / Attendance Status" sortable>
                        <template #body="slotProps">
                            <span v-if="slotProps.data.maintenance_status && slotProps.data.maintenance_status.asset_page_label.length != 0">
                                <i class="status_icon" :style="{ 'background-color': slotProps.data.maintenance_status.value }"></i>
                                <span class="status_text">
                                    {{ slotProps.data.maintenance_status.asset_page_label}}
                                </span>
                            </span>
                            <span v-else>
                                <i>Schedule Not Configured</i>
                            </span>
                        </template>
                    </Column>
                    <Column field="maintenance_current_status" header="Last Report" sortable>
                        <template #body="slotProps">
                            <span v-if="slotProps.data.maintenance_current_status">
                                <i v-if="slotProps.data.maintenance_current_status == 'Pass'" :style="{ 'background-color': '#439446' }" class="status_icon"></i>
                                <i v-if="slotProps.data.maintenance_current_status == 'Fail'" :style="{ 'background-color': '#f44336' }" class="status_icon"></i>
                                <i v-if="slotProps.data.maintenance_current_status == 'Fault'" :style="{ 'background-color': '#1f5ea4' }" class="status_icon"></i>
                                <span class="status_text">{{ slotProps.data.maintenance_current_status }}</span>
                            </span>
                            <span v-else>
                                <i v-if="slotProps.data.asset_type == 'Asset'">Never Maintained</i>
                                <i v-else>Never Attended</i>
                            </span>
                        </template>
                    </Column>
                    <Column field="warranty_status.asset_page_label" header="Warranty Status" sortable>
                        <template #body="slotProps">
                            <span v-if="slotProps.data.warranty_status && slotProps.data.warranty_status.asset_page_label.length != 0">
                                <i class="status_icon" :style="{ 'background-color': slotProps.data.warranty_status.value }"></i>
                                <span class="status_text">{{ slotProps.data.warranty_status.asset_page_label }}</span>
                            </span>
                            <span v-else>
                                <i v-if="slotProps.data.asset_type == 'Asset'">No Warranty</i>
                                <i v-else>N/A</i>
                            </span>
                        </template>
                    </Column>
                    <Column field="lifecycle_status.asset_page_label" header="Lifecycle Status" sortable>
                        <template #body="slotProps">
                            <span v-if="slotProps.data.lifecycle_status && slotProps.data.lifecycle_status.asset_page_label.length != 0">
                                <i class="status_icon" :style="{ 'background-color': slotProps.data.lifecycle_status.value }"></i>
                                <span class="status_text">{{ slotProps.data.lifecycle_status.asset_page_label }}</span>
                            </span>
                            <span v-else>
                                <i v-if="slotProps.data.asset_type == 'Asset'">No Lifecycle</i>
                                <i v-else>N/A</i>
                            </span>
                        </template>
                    </Column>
                    <Column field="fault_info.fault_status" header="Fault Status" sortable>
                        <template #body="slotProps">
                            <span v-if="slotProps.data.fault_info">
                                <div class="p-d-flex" style="align-items: baseline;">
                                    <i class="status_icon" :style="{ 'background-color': slotProps.data.faultMeta.hex }"></i>
                                    <span> &nbsp;
                                        {{ slotProps.data.faultMeta.label }}
                                    </span>
                                </div>
                            </span>
                            <span v-else>
                                <i class="status_icon" :style="{ 'background-color': slotProps.data.faultMeta.hex }"></i>
                                <i> No Fault</i>
                            </span>
                        </template>
                    </Column>
                    <Column bodyClass="edit_col">
                        <template #body="slotProps">
                            <router-link class="edit_link" v-if="slotProps.data.asset_type" :to="{ name: 'asset', params: { id: slotProps.data.key, site_id: slotProps.data.site_id, template_id: slotProps.data.template_id } }">
                                VIEW
                            </router-link>

                            <Button v-else type="button" label="Select Asset Type" class="p-button-secondary" style="width: max-content;" @click.prevent="selectAssetType = true, typeSelectorAsset = [slotProps.data.key, slotProps.data.asset_type]" />
                        </template>
                    </Column>
                </DataTable>

                <!-- UPDATE ASSET TYPE MODAL -->
                <Dialog header="Select Asset Type" :visible.sync="selectAssetType" :modal="true" :contentStyle="{ overflow: 'visible' }">
                    <div class="p-mb-2">
                        <p>Select the Asset Type of the selected Asset below.</p>
                    </div>
                    <Dropdown v-model="typeSelectorAsset[1]" :options="typeFields" placeholder="Asset Type" @change="updateAssetType(typeSelectorAsset[0], typeSelectorAsset[1])" />
                </Dialog>
                <!-- UPDATE ASSET TYPE MODAL -->

                <Paginator :key="tableKey" v-if="!useFilteredValues" class="pre_filter_pagination" :rows="20" :totalRecords="tableLength" @page="updatePage($event)"></Paginator>

                <!-- Bulk Edit Sidebar -->
                <Sidebar :visible.sync="toggleSidebar" position="right" id="bulk_edit_sidebar" @show="checkAssetTypeAvail()" @hide="fieldToEdit = null, selectedValue = null, selectedExportType = null">
                    <h2>Bulk Edit</h2>
                    <p><span>{{ selectedRows.length }}</span> Item<span v-if="selectedRows.length > 1">s</span> Selected
                    </p>
                    <h4>Edit</h4>

                    <div class="p-float-label" style="margin-top: 2rem; max-width: 100%;">
                        <Dropdown v-model="fieldToEdit" :options="editableFields" optionLabel="label" />
                        <label>Select field to edit</label>
                    </div>

                    <!-- select field to edit -->
                    <div v-if="(fieldToEdit && !triggerNewItem) &&
                        (fieldToEdit.value != 'warranty_warning' && fieldToEdit.value != 'maintenance_frequency')" class="p-d-flex p-ai-end" style="gap: 1rem;">
                        <div class="p-float-label" style="margin-top: 2rem; flex-grow:1; max-width: 100%;">
                            <Dropdown v-model="selectedValue" :options="fieldOptions" class="selector_label" />
                            <label>Select {{ fieldToEdit.label }}</label>
                        </div>
                        <Button v-if="fieldToEdit.value != 'asset_type'" type="button" icon="pi pi-plus" class="p-button-secondary" @click.prevent="triggerNewItem = true" style="height:fit-content; bottom:1px;" :disabled="(newFieldValue) ? true : false" />
                    </div>

                    <div v-if="fieldToEdit">
                        <div v-if="fieldToEdit.value == 'warranty_warning'" class="p-float-label" style="margin-top: 2rem; flex-grow:1;">
                            <Dropdown v-model="selectedValue" :options="warrantyWarningoptions" optionLabel="label" />
                            <label>Select {{ fieldToEdit.label }}</label>
                        </div>
                    </div>

                    <div v-if="fieldToEdit">
                        <div v-if="fieldToEdit.value == 'maintenance_frequency'" class="p-float-label" style="margin-top: 2rem; flex-grow:1;">
                            <Dropdown v-model="selectedValue" :options="maintenanceFrequencyoptions" optionLabel="label" />
                            <label>Select {{ fieldToEdit.label }}</label>
                        </div>
                    </div>

                    <!-- add new field value -->
                    <div v-if="triggerNewItem" class="p-d-flex p-ai-end" style="gap: 0.5rem;">
                        <InputText type="text" :placeholder="'Enter new ' + fieldToEdit.value" style="margin-top: 2rem; flex-grow:1;" v-model="newFieldValue" />
                        <Button type="button" icon="pi pi-times" severity="danger" class="p-button-danger" style="border: 0;" @click.prevent="triggerNewItem = false, newFieldValue = ''" />
                        <Button type="button" icon="pi pi-check" class="p-button-secondary" :disabled="(newFieldValue) ? false : true" @click.prevent="addNewFieldValue()" />
                    </div>

                    <div class="p-d-flex p-ai-baseline" style="gap: 0.5rem;">
                        <Button :disabled="((bulkEditRunning || triggerNewItem || !selectedValue) || selectedRows.length < 1) ? true : false" style="margin-top: 1rem;" type="button" label="Save" @click.prevent="saveBulkEdit()" />
                        <i v-if="bulkEditRunning" class="pi pi-spin pi-spinner" style="font-size: 1rem"></i>
                    </div>

                    <div style="margin-top: 4rem;" v-if="user.role.permissionLevel == 10">
                        <h4>Import Data from CSV</h4>
                        <Button type="button" label="Import CSV" @click.prevent="displayImport = true" />
                    </div>

                    <div style="margin-top: 4rem;">
                        <h4>Export</h4>
                        <div class="p-float-label" style="margin-top: 2rem; flex-grow:1;">
                            <Dropdown v-model="selectedExportType" :options="exportOptions" optionLabel="label" />
                            <label>Select Export Type</label>
                        </div>
                        <div v-if="(selectedExportType != null && selectedExportType.value == 'importer_CSV')">
                            <Button style="margin-top: 1rem;" type="button" label="Generate" @click.prevent="generateImporterCSV(useFilteredValues)" :loading="exportLoading" />
                            <br>
                            <small style="margin-top: 1rem; display: block;">NOTE - this exports all assets available in
                                the
                                table.</small>
                        </div>
                        <Button v-else :disabled="(selectedExportType) ? false : true" style="margin-top: 1rem;" type="button" label="Export" @click.prevent="exportData(QRType.value)" :loading="exportLoading" />
                        <div v-if="(selectedExportType && selectedExportType.value == 'QR')" class="p-float-label" style="margin-top: 2rem; flex-grow:1;">
                            <Dropdown v-model="QRType" :options="[{ label: 'Relative URLs', value: true }, { label: 'Absolute URLs', value: false }]" optionLabel="label" />
                            <label>Select QR Code Type</label>
                        </div>
                    </div>
                </Sidebar>

                <!-- Add Batch Sidebar -->
                <Sidebar :visible.sync="visibleRight" :baseZIndex="1000" position="right">
                    <h1 style="font-weight: normal">Add Batch</h1>
                    <div class="p-float-label p-my-5">
                        <InputText id="last_id" type="text" v-model="set_last_id" disabled />
                        <label for="last_id">Last ID</label>
                    </div>
                    <div class="p-float-label p-my-5">
                        <InputNumber id="quantity" v-model="selected.quantity" :min="1" />
                        <label for="quantity">Batch Quantity</label>
                    </div>
                    <div class="p-float-label p-my-4">
                        <InputText id="new_id" type="text" v-model="new_id" disabled />
                        <label for="new_id">New ID</label>
                    </div>
                    <div class="p-d-flex" style="gap: .5rem;">
                        <Button type="button" @click="createBatch(parseInt(site.last_id), parseInt(selected.quantity), site.key)" label="Create" class="p-button-success" />
                        <Button type="button" @click="visibleRight = false" label="Cancel" class="p-button-secondary" />
                    </div>
                </Sidebar>

                <!-- import data dialog -->
                <Dialog header="Import CSV" :visible.sync="displayImport" :style="{ width: '50vw' }" :modal="true">
                    <Importer @importSuccess="importSuccess()" :siteAssets="siteAssets"></Importer>
                </Dialog>

                <!-- delete assets dialog -->
                <Dialog header="Confirmation" :visible.sync="displayConfirmation" :style="{ width: '350px' }" :modal="true">
                    <div class="p-d-flex p-ai-center">
                        <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem" />
                        <span>Are you sure you want to delete these assets?</span>
                    </div>
                    <template #footer>
                        <Button label="No" icon="pi pi-times" @click="displayConfirmation = false" class="p-button-text" />
                        <Button label="Yes" icon="pi pi-check" @click="triggerDelete()" class="p-button-text" autofocus />
                    </template>
                </Dialog>

                <Dialog :visible.sync="triggerCSVTemplateDownloadPrompt" modal header="Batch Created"
                    :breakpoints="{ '1199px': '75vw', '575px': '90vw' }">
                    <p>
                        You've successfully created a new Batch of Assets, Would you like to generate a CSV template for
                        Bulk Importing?
                    </p>
                    <template #footer>
                        <Button label="Generate CSV Template" icon="pi pi-check" @click="triggerCSVTemplateDownloadPrompt = false, generateCSVTemplate(true)" autofocus />
                        <Button label="Close" icon="pi pi-times" @click="triggerCSVTemplateDownloadPrompt = false, generateCSVTemplate(false)" autofocus />
                    </template>
                </Dialog>
            </div>
        </div>
        <Toast />
    </div>
</template>

<script>
import { db } from '@/firebase.js';
import jspdf from 'jspdf';
import QRious from 'qrious';
import moment from 'moment';
import axios from 'axios';
import Importer from '../components/Importer.vue';
import { mapState, mapGetters, mapActions } from 'vuex';


export default {
    props: ['user'],
    components: {
        Importer
    },
    data() {
        return {
            installDatePreParse: null,
            warrantyDatePreParse: null,
            maintainanceDatePreParse: null,
            maintenanceScheduleStartDatePreParse: null,
            lifecycleDatePreParse: null,
            QRType: { label: 'Absolute URLs', value: false },
            filterOptions: {},
            fault_status_sender: [],
            // bulk editing
            selectedRows: [],
            selectedValue: null,
            typeFields: [
                'Asset',
                'Location'
            ],
            assetTypeAvail: true,
            editableFields: [

            ],
            fieldToEdit: null,
            bulkEditRunning: false,
            exportOptions: [{ label: 'Export QR Codes', value: 'QR' }, { label: 'Export CSV', value: 'CSV' }, { label: 'Generate Importer CSV', value: 'importer_CSV' }],
            selectedExportType: null,
            displayConfirmation: false,
            displayImport: false,
            // bulk editing end
            name_list: [],
            category_list: [],
            make_list: [],
            model_list: [],
            location_list: [],
            area_list: [],
            asset_type_list: [],
            lifecycle_status_list: [],
            warranty_status_list: [],
            maintenance_status_list: [],
            maintenance_current_status_list: [],
            warrantyWarningoptions: [
                { label: '1 Week', value: 604800 },
                { label: '1 Month', value: 2630000 },
                { label: '3 Months', value: 7890000 },
                { label: '6 Months', value: 15780000 },
                { label: '1 Year', value: 31560000 }
            ],
            maintenanceFrequencyoptions: [
                { label: 'Daily', value: 86400, threshold: 10800 }, // 10800 = 3 hours for a 2 hour threshold
                { label: 'Weekly', value: 604800, threshold: 172800 },
                { label: 'Monthly', value: 2630000, threshold: 604800 },
                { label: 'Quarterly', value: 7890000, threshold: 1209600 },
                { label: '6 Monthly', value: 15780000, threshold: 2630000 },
                { label: 'Annually', value: 31560000, threshold: 2630000 }
            ],
            // filtering data end
            toggleSidebar: false,
            triggerNewItem: false,
            newFieldValue: '',
            loading: true,
            site: {},
            siteAssets: [],
            siteTasks: [],
            client: {},
            selected: {
                quantity: 1,
            },
            visibleRight: false,
            siteAssetSnapshot: [],
            siteAssetSnapshotData: [],
            pages: [],
            tableLength: 0,
            filterResults: null,
            batchImportArray: [],
            triggerCSVTemplateDownloadPrompt: false,
            exportLoading: false,
            selectAssetType: false,
            typeSelectorAsset: [],
            tableKey: 0, // Key to force DataTable remount
            faultStatusValues: [
                { value: '', label: 'No Fault', hex: '#439446' },
                { value: 'active', label: 'Fault', hex: '#f31b2b' },
                { value: 'in_progress', label: 'In Progress', hex: '#ffbf00' },
                { value: 'rectified', label: 'Rectified', hex: '#1f5ea4' },
            ]
        }
    },
    firestore() {
        return {
            filterOptions: db.collection('filters').doc(this.$route.params.id),// filter key matches site id
            site: db.collection('sites').doc(this.$route.params.id),
            client: db.collection('clients').doc(this.$route.params.client_id),
            // batches: db.collection('asset_batches'),
            // assets: db.collection('assets'),
            tasks: {
                ref: db.collection('maintenance'),
                resolve: (data) => {
                    let siteTasks = [];
                    data.forEach(task => {
                        this.siteAssets.forEach(asset => {
                            if (task.asset_id == asset.key) {
                                if (task.timestamps.created) {
                                    task.timestamps.created_friendly = moment(task.timestamps.created).format('YYYY-MM-DD HH:mm:ss');
                                }
                                if (task.timestamps.complete) {
                                    task.timestamps.complete_friendly = moment(task.timestamps.complete).format('YYYY-MM-DD HH:mm:ss');
                                }
                                siteTasks.push({ asset_number: asset.asset_id, ...task });
                            }
                        })
                    });
                    this.siteTasks = siteTasks;
                }
            }
        }
    },
    computed: {
        ...mapState({ 'stateUser': 'user' }),
        ...mapGetters('assetFilters', ['getCurrentSiteFilters', 'getPagination', 'getUseFilteredValues']),
        AssetFilters: {
            get() {
                return this.getCurrentSiteFilters;
            },
            set(value) {
                this.setSiteFilters({ siteId: this.$route.params.id, filters: value });
            }
        },
        pagination: {
            get() {
                return this.getPagination;
            },
            set(value) {
                this.setPagination(value);
            }
        },
        useFilteredValues: {
            get() {
                return this.getUseFilteredValues;
            },
            set(value) {
                this.setUseFilteredValues(value);
            }
        },
        lifecycle_status_sender: {
            get() {
                return this.AssetFilters.lifecycle_status || [];
            },
            set(value) {
                // Get current filters directly from store to avoid spreading default values
                const currentFilters = this.$store.getters['assetFilters/getCurrentSiteFilters'];
                const updatedFilters = { ...currentFilters };
                updatedFilters.lifecycle_status = value;
                this.setSiteFilters({ siteId: this.$route.params.id, filters: updatedFilters });
            }
        },
        warranty_status_sender: {
            get() {
                return this.AssetFilters.warranty_status || [];
            },
            set(value) {
                const updatedFilters = { ...this.AssetFilters };
                updatedFilters.warranty_status = value;
                this.setSiteFilters({ siteId: this.$route.params.id, filters: updatedFilters });
            }
        },
        maintenance_status_sender: {
            get() {
                return this.AssetFilters.maintenance_status || [];
            },
            set(value) {
                const updatedFilters = { ...this.AssetFilters };
                updatedFilters.maintenance_status = value;
                this.setSiteFilters({ siteId: this.$route.params.id, filters: updatedFilters });
            }
        },
        origin() {
            return window.location.origin;
        },
        fieldOptions() {
            // console.log(this.filterOptions[`${this.fieldToEdit.value}`])
            if (this.fieldToEdit.value == 'asset_type') {
                console.log(this.fieldToEdit.value)
                let options = ['', 'Asset', 'Location'];
                return options;
            } else {
                let options = (this.fieldToEdit.value != null) ? this.filterOptions[`${this.fieldToEdit.value}`] : [];
                return options;
            }
        },
        new_id() {
            return isNaN(this.site.last_id) ? 0 + parseInt(this.selected.quantity) : (parseInt(this.site.last_id)) + parseInt(this.selected.quantity);
        },
        filename() {
            if (this.site.name != undefined) {
                return this.site.name.toLowerCase() + '_maintenance'
            } else {
                return null
            }
        },
        set_last_id() {
            return isNaN(this.site.last_id) ? 0 : this.site.last_id;
        }
    },
    mounted() {
        // Initialize store with current site ID
        this.setSiteFilters({ siteId: this.$route.params.id, filters: this.getCurrentSiteFilters });
        // Check if any filters are active and trigger search if they are
        const filters = this.getCurrentSiteFilters;
        const hasActiveFilters = filters.asset_id || Object.values(filters).some(value => Array.isArray(value) && value.length > 0);
            
        if (hasActiveFilters) {
            this.searchFilters();
        } else {
            this.updatePage({ page: 0 }); // initialises asset list
        }
        
        // Sync date values from store
        this.syncDateValuesFromStore();
        
        this.initPagination();
    },
    methods: {
        ...mapActions('assetFilters', ['setSiteFilters', 'setPagination', 'setUseFilteredValues', 'clearSiteFilters', 'clearAllFilters']),
        syncDateValuesFromStore() {
            const filters = this.getCurrentSiteFilters;
            
            // Convert Unix timestamps to Date objects for Calendar components
            if (filters.install_date && filters.install_date.length === 2) {
                this.installDatePreParse = [new Date(filters.install_date[0] * 1000), new Date(filters.install_date[1] * 1000)];
            }
            if (filters.warranty_expiry_date && filters.warranty_expiry_date.length === 2) {
                this.warrantyDatePreParse = [new Date(filters.warranty_expiry_date[0] * 1000), new Date(filters.warranty_expiry_date[1] * 1000)];
            }
            if (filters.last_maintained_date && filters.last_maintained_date.length === 2) {
                this.maintainanceDatePreParse = [new Date(filters.last_maintained_date[0] * 1000), new Date(filters.last_maintained_date[1] * 1000)];
            }
            if (filters.maintenance_schedule_start_date && filters.maintenance_schedule_start_date.length === 2) {
                this.maintenanceScheduleStartDatePreParse = [new Date(filters.maintenance_schedule_start_date[0] * 1000), new Date(filters.maintenance_schedule_start_date[1] * 1000)];
            }
            if (filters.lifecycle_expiry_date && filters.lifecycle_expiry_date.length === 2) {
                this.lifecycleDatePreParse = [new Date(filters.lifecycle_expiry_date[0] * 1000), new Date(filters.lifecycle_expiry_date[1] * 1000)];
            }
        },
        getDefaultFilters() {
            return {
                asset_id: null,
                name: [],
                category: [],
                asset_type: [],
                location: [],
                area: [],
                make: [],
                model: [],
                install_date: [],
                lifecycle_expiry_date: [],
                last_maintained_date: [],
                maintenance_schedule_start_date: [],
                warranty_expiry_date: [],
                lifecycle_status: [],
                warranty_status: [],
                maintenance_status: [],
                maintenance_current_status: [],
                fault_status: []
            };
        },
        initPagination() {

            const paginationUrl = process.env.VUE_APP_API_URL + '/init/pagination';

            axios({
                method: 'post',
                url: paginationUrl,
                headers: {
                    'Authorization': `Bearer ${this.stateUser.auth.accessToken}`
                },
                data: {
                    'siteId': this.$route.params.id,
                }
            }).then((response) => {
                this.tableLength = response.data.size;
                // console.log(this.siteAssetSnapshotData)
            }).catch(error => { console.error(error) });
        },
        formatStatuses(statuses, sender) { // sets object filters into correct format for api
            sender.forEach((status, index) => {
                status = { asset_page_label: status };
                statuses[index] = status
            })
        },
        async searchFilters() {
            this.setUseFilteredValues(true);
            this.loading = true;
            this.siteAssetSnapshotData = [];
            this.selectedRows = [];

            let postFilters = { ...this.AssetFilters };
            
            // Remove asset_id if it's null or empty
            if (!postFilters.asset_id) {
                delete postFilters.asset_id;
            }
            
            postFilters.lifecycle_status = [];
            postFilters.maintenance_status = [];
            postFilters.warranty_status = []; // set values for sending to api

            if (this.lifecycle_status_sender && this.lifecycle_status_sender.length) {
                this.formatStatuses(postFilters.lifecycle_status, this.lifecycle_status_sender);
            }
            if (this.maintenance_status_sender && this.maintenance_status_sender.length) {
                this.formatStatuses(postFilters.maintenance_status, this.maintenance_status_sender);
            }
            if (this.warranty_status_sender && this.warranty_status_sender.length) {
                this.formatStatuses(postFilters.warranty_status, this.warranty_status_sender);
            }
            const faultValues = postFilters.fault_status;
            let faultStatuses = []
            if (postFilters.fault_status.length) {
                postFilters.fault_status.forEach(fault => {
                    if(this.faultStatusValues.find(data => data.label === fault)) {
                        faultStatuses.push(this.faultStatusValues.find(data => data.label === fault).value) // only value is required for filtering
                    } else {
                        // if user is looking for 'no faults' use value to find the correct fault status
                        faultStatuses.push(this.faultStatusValues.find(data => data.value === fault).value)
                    }
                });

                postFilters.fault_status = faultStatuses
            }

            const filterUrl = process.env.VUE_APP_API_URL + '/filter';

            axios({
                method: 'post',
                url: filterUrl,
                headers: {
                    'Authorization': `Bearer ${this.stateUser.auth.accessToken}`
                },
                data: {
                    'siteId': this.$route.params.id,
                    filterOptions: postFilters // send filter values
                }
            }).then((response) => {
                this.siteAssetSnapshotData = response.data;
                this.siteAssetSnapshotData.forEach((asset) => {
                    asset.faultMeta = (asset.fault_info) ? this.setIndividualFaultStatus(asset.fault_info.fault_status) : this.setIndividualFaultStatus('')
                })

                this.updatePage({ page: 0 })
                this.loading = false;
                this.setPagination({ first: 0 });
                // Force DataTable to remount after search
                this.tableKey++;
                // console.log(this.siteAssetSnapshotData)
                postFilters.fault_status = faultValues
            }).catch(error => { console.error(error) });

        },
        pushFilters() { // only required temporarily

            const filterSetUrl = process.env.VUE_APP_API_URL + '/filter/set';

            axios({
                method: 'post',
                url: filterSetUrl,
                headers: {
                    'Authorization': `Bearer ${this.stateUser.auth.accessToken}`
                },
                data: {
                    'siteId': this.$route.params.id,
                }
            }).then((response) => {
                console.log(response)
                this.loading = false;
            }).catch(error => { console.error(error) });

        },
        clearFilters() {
            this.setUseFilteredValues(false);
            this.loading = true;
            
            // Reset filters to default values instead of clearing them completely
            this.setSiteFilters({ siteId: this.$route.params.id, filters: this.getDefaultFilters() });
            
            this.fault_status_sender = [];
            this.installDatePreParse = null;
            this.warrantyDatePreParse = null;
            this.lifecycleDatePreParse = null;
            this.maintainanceDatePreParse = null;
            this.maintenanceScheduleStartDatePreParse = null;
            this.siteAssetSnapshot = [];
            this.updatePage({ page: 0 });
            // Force DataTable to remount when clearing filters
            this.tableKey++;
        },
        updatePage(e) {
            if (this.useFilteredValues) {
                console.log('using fil;ter')
            } else {
                let defaultQuery = db.collection('assets').where('client_id', '==', this.$route.params.client_id).where('site_id', '==', this.$route.params.id).orderBy('asset_id', 'asc').limit(20)
                let start = this.pages[e.page] != undefined ? this.pages[e.page] : 0;
                let siteAssetSnapshot = [];
                if (!this.siteAssetSnapshot.length) {
                    siteAssetSnapshot = defaultQuery;
                } else {
                    if (start == 0) {
                        siteAssetSnapshot = defaultQuery.startAfter(this.siteAssetSnapshot[this.siteAssetSnapshot.length - 1]);
                    } else {
                        siteAssetSnapshot = defaultQuery.startAt(start);
                    }
                }

                siteAssetSnapshot.get().then((assetsSnapshot) => {
                    this.siteAssetSnapshot = [];
                    this.siteAssetSnapshotData = [];

                    assetsSnapshot.forEach(doc => {
                        this.siteAssetSnapshot.push(doc);
                        let data = doc.data();
                        data.key = doc.id; // combine key and data for table listing
                        data.faultMeta = (doc.data().fault_info) ? this.setIndividualFaultStatus(doc.data().fault_info.fault_status) : this.setIndividualFaultStatus('')
                        this.siteAssetSnapshotData.push(data);
                    });

                    this.loading = false;
                    if (this.pages[e.page] == undefined) {
                        this.pages.push(this.siteAssetSnapshot[0]); // push to pages for startAt query, so next query starts at the last item
                        this.loading = false;
                    }
                })
            }
        },
        setIndividualFaultStatus(faultValue) {
            // console.log(this.current_fault_status)
            return this.faultStatusValues.find(x => x.value == faultValue)
        },
        importSuccess() {
            this.displayImport = false;
            this.toggleSidebar = false;
            this.loading = true;
            this.pushFilters();
            this.siteAssetSnapshot = [];
            this.updatePage({ page: 0 });
            // Force DataTable to remount after import
            this.tableKey++;
        },
        generateCSVTemplate(trigger) {

            if (trigger) { // bool

                const generateCSVTemplateUrl = process.env.VUE_APP_API_URL + '/export/page/assets/csv-template';

                axios({
                    method: 'post',
                    url: generateCSVTemplateUrl,
                    headers: {
                        'Authorization': `Bearer ${this.stateUser.auth.accessToken}`
                    },
                    data: {
                        rows: this.batchImportArray, // send filter values
                    }
                }).then((response) => {
                    if (response.data.message) { // message only shows if error thrown in promise in API
                        this.$toast.add({ severity: 'error', summary: 'Error', detail: response.data.message, life: 3000 })
                    } else { // if no message, successful download
                        const anchor = document.createElement('a');
                        anchor.href = response.data.URL;
                        anchor.target = '_blank';
                        anchor.click();
                    }
                }).catch(error => { console.error(error) });

            }

            this.batchImportArray = [];
            this.triggerCSVTemplateDownloadPrompt = false;
        },
        checkAssetTypeAvail() {

            let assetTypeAvail = true,
                firstItem = [{ label: 'Asset Type', value: 'asset_type' }],
                selectedAssetTypes = [],
                allFields = [
                    { label: 'Name', value: 'name', universal: true }, // universal bool - if false, gets caught by firebase check in saveBulkEdit and removed for location asset types
                    { label: 'Category', value: 'category', universal: false },
                    { label: 'Make', value: 'make', universal: false },
                    { label: 'Model', value: 'model', universal: false },
                    { label: 'Sub-Area', value: 'location', universal: true },
                    { label: 'Area', value: 'area', universal: true },
                    { label: 'Warranty Warning Threshold', value: 'warranty_warning', universal: false },
                    { label: 'Maintenance / Attendance Frequency', value: 'maintenance_frequency', universal: true }
                ],
                locationFields = [
                    { label: 'Name', value: 'name', universal: true },
                    { label: 'Sub-Area', value: 'location', universal: true },
                    { label: 'Area', value: 'area', universal: true },
                    { label: 'Maintenance / Attendance Frequency', value: 'maintenance_frequency', universal: true }
                ];



            // The below code is iterating over the selectedRows array and checking if each row has a
            // non-empty asset_type property. If a row has an asset_type, it sets the assetTypeAvail
            // variable to false and adds the asset_type to the selectedAssetTypes array.
            this.selectedRows.forEach(row => {
                selectedAssetTypes.push(row.asset_type);
                if (row.asset_type != '') { // if row has asset type, set bool to false
                    assetTypeAvail = false;
                }
            });

            if (assetTypeAvail == false) {
                console.log(selectedAssetTypes);
                if (selectedAssetTypes.includes('Asset') && !selectedAssetTypes.includes('') && !selectedAssetTypes.includes('Location')) {
                    this.editableFields = allFields; // if mixed asset types, result will be sanitizes in saveBulkEdit()
                } else {
                    this.editableFields = locationFields;
                }

            } else {
                this.editableFields = firstItem.concat(locationFields);
            }
        },
        updateAssetType(assetID, assetType) {
            db.collection('assets').doc(assetID).update({
                asset_type: assetType
            }).then(() => {
                if (assetType == 'Location') {
                    db.collection('assets').doc(assetID).update({
                        additional_info: '',
                        primary_contact_email: '',
                        primary_contact_name: '',
                        primary_contact_phone: '',
                        secondary_contact_email: '',
                        secondary_contact_name: '',
                        secondary_contact_phone: '',
                    }).then(() => {
                        this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Asset Type Assigned', life: 3000 });
                    })
                } else {
                    db.collection('assets').doc(assetID).update({
                        install_date: new Date(),
                    }).then(() => {
                        this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Asset Type Assigned', life: 3000 });
                    })
                }
                if (this.siteAssetSnapshotData.length <= 20) { // only triggers on sites with 20 or less items, or on first page - prevents issues with filtered values
                    this.siteAssetSnapshotData.forEach((row) => {
                        if (row.key == assetID) {
                            row.asset_type = assetType;
                        }
                    })
                }
                this.selectAssetType = false;
                this.typeSelectorAsset = [];
            })
        },
        triggerChip() {
            let labels = document.querySelectorAll('.p-multiselect-label');

            labels.forEach((span) => {
                setTimeout(function () {
                    let tokens = span.querySelectorAll('.p-multiselect-token');
                    if (tokens.length) {
                        tokens.forEach((token) => {
                            let span = token.querySelector('.p-multiselect-token-label');
                            if (span.innerHTML == '') {
                                span.innerHTML = 'Unassigned'; // overwrites empty string
                            }
                        })
                    }
                }, 1) // timeout required due to toolkit adding chip to label
            })
        },
        triggerLabel() {
            let emptySpan = event.currentTarget.querySelector('.p-multiselect-item > span:first-of-type'); // selects first item
            emptySpan.innerHTML = 'Unassigned';
        },
        triggerDelete() {
            let iterator = 0;
            this.selectedRows.forEach(row => {
                db.collection('assets').doc(row.key).get().then((asset) => {


                    db.collection('asset_bin').doc(row.key).set({ // moves asset to asset bin collection
                        metadata: asset.data(), // used for restoration
                        deleted_timestamp: new Date(),
                        site_name: this.site.name
                    }).then(() => {

                        db.collection('faults').where('asset_id', '==', row.key).get().then((faults) => {
                            console.log(faults)
                            faults.docs.forEach((fault) => {
                                db.collection('faults').doc(fault.id).update({ asset_deleted: true })
                            })
                            db.collection('assets').doc(row.key).delete().then(() => {

                                iterator++;
                                if (iterator == this.selectedRows.length) {
                                    db.collection('logs').add({
                                        activity: 'Assets Deleted',
                                        timestamp: new Date(),
                                        user: this.user.email,
                                        client_id: this.user.client.key,
                                        site: this.site.name
                                    }).then(() => {
                                        this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Assets Deleted', life: 3000 });
                                        this.displayConfirmation = false;
                                        this.toggleSidebar = false;
                                        this.pushFilters();
                                        this.useFilteredValues = false;
                                        this.siteAssetSnapshot = [];
                                        this.selectedRows = [];
                                        this.updatePage({ page: 0 });
                                        // Force DataTable to remount by incrementing the key
                                        this.tableKey++;
                                        iterator = 0;
                                        console.log(this.pages)
                                    });
                                }
                            });
                        })

                    });
                });

            })
        },
        // The below code is a method called `exportData()` in a Vue component. It is used to export
        // data based on the selected export type.
        exportData(QRType) {
            this.exportLoading = true;
            const exportURL = process.env.VUE_APP_API_URL + '/export/page/assets/csv';

            switch (this.selectedExportType.value) {
                case 'QR':
                    this.download(QRType);
                    this.exportLoading = false;
                    break;
                case 'CSV': {
                    let rows = (this.selectedRows.length) ? this.selectedRows
                        : (this.useFilteredValues == true && !this.selectedRows.length) ? this.siteAssetSnapshotData
                            : [];

                    console.log(rows)

                    axios({
                        method: 'post',
                        url: exportURL,
                        headers: {
                            'Authorization': `Bearer ${this.stateUser.auth.accessToken}`
                        },
                        data: {
                            rows: rows, // send filter values
                            origin: window.location.origin,
                            siteId: this.$route.params.id,
                            permissionLevel: this.user.role.permissionLevel
                        }
                    }).then((response) => {
                        this.exportLoading = false;
                        if (response.data.message) { // message only shows if error thrown in promise in API
                            this.$toast.add({ severity: 'error', summary: 'Error', detail: response.data.message, life: 3000 })
                        } else { // if no message, successful download
                            const anchor = document.createElement('a');
                            anchor.href = response.data.URL;
                            anchor.target = '_blank';
                            anchor.click();
                        }
                    }).catch(error => { console.error(error) });
                    break;
                }
                default:
            }
        },
        saveBulkEdit() {
            this.bulkEditRunning = true;
            let iterator = 0,
                skippedAssets = [],
                successToast = this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Bulk Edit Complete', life: 3000 });

            this.selectedRows.forEach(asset => {
                let dbAsset = db.collection('assets').doc(asset.key);
                if (asset.asset_type == 'Location' && !this.fieldToEdit.universal) {
                    skippedAssets.push(this.forceFourDigits(asset.asset_id))
                    dbAsset.get().then(() => {
                        iterator++;
                        if (iterator == this.selectedRows.length) {
                            this.bulkEditRunning = false;
                            this.newFieldValue = '';
                            if (skippedAssets.length) {
                                successToast;
                                this.$toast.add({
                                    severity: 'info', summary: 'Items Skipped',
                                    detail: 'The following Assets were skipped as the ' + this.fieldToEdit.label + ' field is incompatible: ' + skippedAssets + '',
                                    life: 6000
                                });
                            } else {
                                this.pushFilters();
                                this.updatePage({ page: 0 });
                                successToast;
                            }
                            this.selectedRows = [];
                            this.toggleSidebar = false;
                        }
                    })
                } else {
                    dbAsset.update({
                        [this.fieldToEdit.value]: this.selectedValue // NOTE - this value will need sanitizing when added via api
                    }).then(() => {
                        // console.log(this.selectedValue)
                        iterator++;
                        if (iterator == this.selectedRows.length) {
                            this.bulkEditRunning = false;
                            this.newFieldValue = '';
                            if (skippedAssets.length) {
                                successToast;
                                this.$toast.add({
                                    severity: 'info', summary: 'Items Skipped',
                                    detail: 'The following Assets were skipped as the ' + this.fieldToEdit.label + ' field is incompatible: ' + skippedAssets + '',
                                    life: 10000
                                });
                            } else {
                                this.pushFilters();
                                this.updatePage({ page: 0 });
                                successToast;
                            }
                            this.selectedRows = [];
                            this.toggleSidebar = false;
                        }
                    })
                }
            })
        },
        addNewFieldValue() {
            this.fieldOptions.push(this.newFieldValue);
            this.selectedValue = this.newFieldValue;
            this.triggerNewItem = false;
        },
        triggerClose(value, selector) {
            // console.log(value)
            let array = [];
            value.forEach(function (timestamp) {
                let formattedDate = new Date(timestamp)
                timestamp = formattedDate.getTime();
                array.push(timestamp / 1000);
            });
            
            // Update the filters in the store
            let updatedFilters = { ...this.AssetFilters };
            switch (selector) {
                case 'install_date':
                    updatedFilters.install_date = array;
                    break;
                case 'warranty_expiry_date':
                    updatedFilters.warranty_expiry_date = array;
                    break;
                case 'last_maintained_date':
                    updatedFilters.last_maintained_date = array;
                    break;
                case 'maintenance_schedule_start_date':
                    updatedFilters.maintenance_schedule_start_date = array;
                    break;
                case 'lifecycle_expiry_date':
                    updatedFilters.lifecycle_expiry_date = array;
                    console.log(array)
                    break;
                default:
            }
            this.setSiteFilters({ siteId: this.$route.params.id, filters: updatedFilters });
        },
        forceFourDigits(val) {
            // add zeroes to 
            var numStr = val.toString();
            while (numStr.length < 4) {
                // keep adding zeroes until length is 4
                numStr = "0" + numStr;
            }
            return numStr;
        },
        createBatch(from, number, site_id) {
            if (isNaN(from)) {
                from = 0;
            }

            // Create batch. Get ID of this batch.
            db.collection('asset_batches').add(
                {
                    site_id: site_id,
                    client_id: this.site.client_id,
                    timestamp: new Date(),
                    number: number,
                    from_id: from + 1,
                    to_id: from + number,
                }
            ).then(docRef => {
                let batch = db.batch();
                let i;
                for (i = from + 1; i < from + number + 1; i++) {
                    var newRef = db.collection('assets').doc();
                    batch.set(newRef, {
                        asset_id: i,
                        batch_id: docRef.id,
                        timestamp: new Date(),
                        name: '',
                        asset_type: '',
                        site_id: site_id,
                        client_id: this.site.client_id,
                        category: '',
                        make: '',
                        model: '',
                        description: '',
                        location: '',
                        area: '',
                        warranty: false,
                        warranty_expiry_date: '',
                        first_maintained_date: '',
                        last_maintained_date: '',
                        lifecycle_expiry_date: '',
                        maintenance_frequency: '',
                        maintenance_current_status: '',
                        maintenance_current_company: '',
                        maintenance_current_user: '',
                        maintenance_current_notes: '',
                        lifecycle_status: { asset_page_label: '' },
                        warranty_status: { asset_page_label: '' },
                        maintenance_status: { asset_page_label: '' },

                        warranty_warning: { label: '', value: 0},
                        lifecycle_warning: { label: '', value: 0},
                        fault_info: { fault_status: ''},

                    });

                    this.batchImportArray.push(
                        {
                            asset_id: i,
                            batch_id: docRef.id,
                            timestamp: new Date(),
                            name: '',
                            asset_type: '',
                            site_key: site_id,
                            company_key: this.site.client_id,
                            category: '',
                            make: '',
                            model: '',
                            description: '',
                            sub_area: '',
                            area: '',
                            // asset_type: '', TBC
                            install_date: '',
                            warranty: false,
                            warranty_expiry_date: '',
                            asset_key: newRef.id
                        }
                    )
                }

                this.site.last_id = i;

                batch.commit().then(() => {
                    this.$firestore.site.update({ 'last_id': i - 1 }).then(() => {
                        this.visibleRight = false;
                        db.collection('logs').add({
                            activity: 'New batch created',
                            timestamp: new Date(),
                            user: this.user.email,
                            client_id: this.user.client.key
                        }).then(() => {
                            this.$toast.add({ severity: 'success', summary: 'Success', detail: 'New batch created', life: 3000 });
                            this.pushFilters();
                            this.siteAssetSnapshot = [];
                            this.updatePage({ page: 0 });
                            this.initPagination();

                            this.triggerCSVTemplateDownloadPrompt = true;
                        });
                    });
                });

            });
        },
        download(isRelative) {
            console.log(isRelative)
            let assets = this.selectedRows;

            assets.sort((a, b) => a.asset_id - b.asset_id);

            let doc = new jspdf('portrait', 'mm', 'a4');
            let col = 0, row = 0, pX, pY;

            assets.forEach(asset => {

                let QRValue = (isRelative) ? '/check-in-out/' + this.$route.params.client_id + '/' + asset.site_id + '/' + asset.key
                    : window.location.origin + '/check-in-out/' + this.$route.params.client_id + '/' + asset.site_id + '/' + asset.key;

                if (col == 5) {
                    col = 0;
                    row++;
                }

                let id = asset.asset_id;
                let qr = new Image();

                qr.src = '/logo-qr.png';
                let qr2 = new QRious({
                    value: QRValue,
                    size: 800,
                    level: 'H'
                });

                qr2 = qr2.toDataURL();

                if (col == 0) {
                    pX = 4.75;
                } else {
                    pX = 4.75 + (38.1 * col) + (2.5 * col);
                }

                if (row == 0) {
                    pY = 10.7;
                } else {
                    pY = 10.7 + (21.2 * row);
                }

                doc.setFont('courier', 'bold');
                doc.setFontSize(16);
                doc.text('' + id, pX + 21, pY + 14);
                // doc.addImage(logo, 'PNG', pX + 20, pY + 2, 16, 4);
                doc.addImage(qr2, 'PNG', pX + 1, pY + 1, 19, 19);

                if (row == 12 && col == 4) {
                    doc.addPage();
                    row = 0;
                    col = -1;
                }

                col++;
            });

            doc.save('assets-' + this.site.name + '.pdf');
        },
        generateImporterCSV(isFiltered) {
            // required = if filtered: all rows
            // if not filtered: site id - to get all values

            if (isFiltered) {

                const importerCSVURL = process.env.VUE_APP_API_URL + '/export/page/assets/import-csv/filtered';
                axios({
                    method: 'post',
                    url: importerCSVURL,
                    headers: {
                        'Authorization': `Bearer ${this.stateUser.auth.accessToken}`
                    },
                    data: {
                        'records': this.siteAssetSnapshotData,
                    }
                }).then((response) => {
                    if (response.data.message) { // message only shows if error thrown in promise in API
                        this.$toast.add({ severity: 'error', summary: 'Error', detail: response.data.message, life: 3000 })
                    } else { // if no message, successful download
                        const anchor = document.createElement('a');
                        anchor.href = response.data.URL;
                        anchor.target = '_blank';
                        anchor.click();
                    }
                }).catch(error => { console.error(error) });

            } else {

                const importerCSVURL = process.env.VUE_APP_API_URL + '/export/page/assets/import-csv/unfiltered';
                axios({
                    method: 'post',
                    url: importerCSVURL,
                    headers: {
                        'Authorization': `Bearer ${this.stateUser.auth.accessToken}`
                    },
                    data: {
                        'siteId': this.$route.params.id,
                    }
                }).then((response) => {
                    if (response.data.message) { // message only shows if error thrown in promise in API
                        this.$toast.add({ severity: 'error', summary: 'Error', detail: response.data.message, life: 3000 })
                    } else { // if no message, successful download
                        const anchor = document.createElement('a');
                        anchor.href = response.data.URL;
                        anchor.target = '_blank';
                        anchor.click();
                    }
                }).catch(error => { console.error(error) });

            }
        },

        triggerNewPagination(e) { // required to reset pagination every time search is called
            this.setPagination({ first: e.first });
        },
        updateAssetsButton() {
            const reportFaultEndpoint = process.env.VUE_APP_API_URL + '/fault-overwrite-maintenance'

            axios({
                method: 'post',
                url: reportFaultEndpoint,
            }).then(() => {
            }).catch(error => { console.error(error) });
        }
    }
}
</script>

<style scoped lang="scss">
.status_text {
    padding-left: .5rem;
    bottom: 1px; // aligning text
    position: relative;
}

.edit_link {
    color: #0388E5;
}

.pre_filter_pagination {
    border: solid #e9ecef;
    border-width: 0 0 1px 0;
    padding: 0.5rem 1rem;
    border-radius: 3px;
}
</style>
